import { Theme } from '@/theme';
import styled, { css } from 'styled-components';
import { Misc } from '@/assets/images';

export const Container = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
`;

export const AvatarIcon = styled.div`
  background-repeat: no-repeat;
  background-size: 100%;
  pointer-events: none;
  position: absolute;
  z-index: 1;
`;

export const AvatarIcon1 = styled(AvatarIcon)`
  background-image: url(${Misc.AvatarLeft});
  height: min(115.2vw, 432px);
  width: min(45vw, 169px);
  top: 16%;
  left: 0;
`;

export const AvatarIcon2 = styled(AvatarIcon)`
  background-image: url(${Misc.AvatarTop});
  width: min(46.667vw, 175px);
  height: min(37.6vw, 141px);
  top: 12.5%;
  right: 0;
`;

export const AvatarIcon3 = styled(AvatarIcon)`
  background-image: url(${Misc.AvatarBottom});
  height: min(89.867vw, 337px);
  width: min(49.867vw, 187px);
  right: -5%;
  top: 30%;
`;

type BoxProps = {
  isFocus?: boolean
}

export const Box = styled.div(({ isFocus = false}: BoxProps) => css`
  bottom: calc(8.62vh + ${isFocus ? '300px' : '0px'});

  box-shadow: 0px -4px 4px 0px rgb(222 13 13 / 0.25);
  background-color: ${Theme.color.white};

  padding: 16px 16px 32px;
  border-radius: 16px;
  position: absolute;

  transition: 0.5s;
  margin: 0 auto;

  width: 87.2%;
  z-index: 2;

  right: 0;
  left: 0;
`);

export const Title = styled.h1`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(40)};
  text-transform: uppercase;

  margin-bottom: 8px;
  text-align: center;
  line-height: 90%;
`;

export const Text = styled.p`
  font-size: ${Theme.rems(16)};
  margin-bottom: 16px;
  text-align: center;
  line-height: 140%;
`;
